import React from 'react';
import './DayBox.css';
import PropTypes from 'prop-types';
import { paraigues } from '../../img';
import { getEstCel, tempMaxColor, tempMinColor } from '../../utils/utils';
import Loader from '../../partials/Loader/Loader';

const DayBox = props => {
    const { data, config } = props;

    // Styles
    const estCelIcon = getEstCel(data.est_cel[props.index][0].valor);
    const iconStyle = { backgroundImage: `url(${estCelIcon})` };
    const rainStyle = { backgroundImage: `url(${paraigues})` };
    const tempMaxBgColor = {
        backgroundColor: tempMaxColor(config.color),
    };
    const tempMinBgColor = {
        backgroundColor: tempMinColor(config.color),
    };

    // Vars
    const tempMax = data.temp_max
        ? Math.round(data.temp_max[props.index][0].valor)
        : '';
    const tempMin = data.temp_min
        ? Math.round(data.temp_min[props.index][0].valor)
        : '';
    const probPrec =
        typeof data.prob_prec[props.index][0].valor === 'number'
            ? Math.round(data.prob_prec[props.index][0].valor)
            : data.prob_prec[props.index][0].valor;
    const unitatTemp = config.tempFormat || ' °C';
    const unitatProbPrec =
        typeof data.prob_prec[props.index][0].valor === 'number'
            ? data.prob_prec_unitat || ' %'
            : '';

    
    const precipitacioLenght =  (probPrec+unitatProbPrec).length;    


    if(precipitacioLenght <= 4){
        rainStyle['width'] = 'auto';
    }else if(precipitacioLenght === 6){
        rainStyle['width'] = '40px';
    }else if(precipitacioLenght>6){
        rainStyle['width'] = '60px';
    }

    

    if (!data) {
        return <Loader language={props.config.language} />;
    }
    
    return (
        <div
            className={
                props.onlyOneDayBox === true
                    ? 'mc-widget-day mc-widget-daybox only-dayBox'
                    : 'mc-widget-day mc-widget-daybox'
            }
        >
            <h3>{props.dayName}</h3>
            <div className="mc-widget-daybox__wrapper">
                <div className="mc-widget-daybox__icon" style={iconStyle} />
                <div className="mc-widget-daybox__numbers">
                    <div className="mc-widget-daybox__temp">
                        {(tempMax || tempMax === 0) && (
                            <div
                                className="mc-widget-daybox__temp-max"
                                style={tempMaxBgColor}
                            >
                                <span>
                                    {tempMax}
                                    {unitatTemp}
                                </span>
                            </div>
                        )}
                        {(tempMin || tempMin === '0') && (
                            <div
                                className="mc-widget-daybox__temp-min"
                                style={tempMinBgColor}
                            >
                                <span>
                                    {tempMin}
                                    {unitatTemp}
                                </span>
                            </div>
                        )}
                    </div>
                    {(probPrec || probPrec === 0) && (
                        <div
                            className="mc-widget-daybox__rain"
                            style={rainStyle}
                        >
                            {probPrec}
                            {unitatProbPrec}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

DayBox.propTypes = {
    config: PropTypes.shape({
        alternativeTitle: PropTypes.string,
        color: PropTypes.string,
        language: PropTypes.string,
        location: PropTypes.string,
        type: PropTypes.string,
        variables: PropTypes.arrayOf(PropTypes.string),
    }),
    data: PropTypes.object,
    dayName: PropTypes.string,
    index: PropTypes.number,
};

export default DayBox;



// WEBPACK FOOTER //
// ./src/partials/DayBox/DayBox.js